<template>
  <div class="page-about" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header title="About">
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg">

      <about-sub-section id="about-partner-1" name="bosshog::about-partner-1"></about-sub-section>

      <!-- <about-sub-section id="about-partner-2" name="bosshog::about-partner-2" is-alt="true"></about-sub-section> -->

      <about-sub-section id="about-partner-3" name="bosshog::about-partner-3"></about-sub-section>

    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import PageHeader from '@/components/PageHeader'
import PageSubheader from '@/components/PageSubheader'
import TopSubpageSection from '@/components/TopSubpageSection'
import AboutSubSection from './AboutSubSection'

export default {
  name: 'about',
  components: {
    DivContainer,
    PageHeader,
    PageSubheader,
    TopSubpageSection,
    AboutSubSection
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-about {
  position: relative;
  background-color: $color-beige;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }
}

</style>



// WEBPACK FOOTER //
// About.vue?a1339062